import firebase from 'firebase/app';

const database = firebase.database();

if (process.env.REACT_APP_ENVIRONMENT_NAME === 'EMULATOR') {
  database.useEmulator('localhost', 9000);
}

export default database;
